import { axiosInstance } from './api'

export const getContactUsSubmissionsReport = (clubId, branchId, startDate, endDate) => {
    const url = `ContactUs/GetContactUsSubmissionReport?clubId=${+clubId > 0 ? clubId : ''}&branchId=${+branchId > 0 ? branchId : ''}&from=${startDate}&to=${endDate}`;
    return axiosInstance().get(url);
}

